module.exports = __webpack_public_path__ + "img/gaffer_(duct)tape.fb4f4224.jpg";